<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
      </el-form>
      <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addOpenclass" class="but-cls">
        添加公开课
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteOpenclassMore" class="but-cls">删除公开课
      </el-button>
      <el-table
          :data="OpenclassData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="openClassName"
            label="名称"
        >
       </el-table-column>
        <el-table-column
            prop="openClassNameEn"
            label="英文名称"
        >
        </el-table-column>
        <el-table-column
            prop="courseCategoryName"
            label="所属分类"
        >
         </el-table-column>
        <el-table-column
            prop="teacherName"
            label="教师"
        >
         </el-table-column>
        <el-table-column
            prop="openClassDate"
            label="开始日期"
        >
         </el-table-column>
        <el-table-column
            prop="openClassBeginTime"
            label="开始时间"
        >
         </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateOpenclass(scope.row)">修改</el-button>
            <el-button @click="deleteOpenclass(scope.$index, scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="showOpenclass(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        OpenclassData: [],
        href: '',
        searchData: {
          size: 10,
          page: 1,
          orgCode: 'blcuonline'
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addOpenclass() {
        this.$router.push({
          name: 'addopenclass',
          params: {'title': '添加公开课内容！'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].id;
        }
      },
      updateOpenclass(row) {
        this.$router.push({
          name: 'addopenclass',
          params: row
        });
      },
      showOpenclass(row) {
        let params = {
          openClassId: row.id
        };
        https.fetchPost(https.openclassURL + '?openClassId=' + row.id, params, 'json').then((data) => {
           console.log(data);
           var url = data.data.split("*")[1];
           window.open(url, '_blank');
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
      },
      deleteOpenclassMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条公开课, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {'openClassIdList': multipleSelection};
          https.fetchPost('/webOpenClass/deleteOpenClass', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteOpenclass(index, row) {
        this.$confirm('此操作将删除该感言, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {'openClassIdList': []};
          params.openClassIdList.push(row.id);
          https.fetchPost('/webOpenClass/deleteOpenClass', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        // this.searchData.resourceCategoryId = this.searchData.id;
        let params = this.searchData;
        https.fetchPost('/webOpenClass/list', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.OpenclassData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      loadOrganization() {
        let params = {};
        https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            let d = data.data.data;
            if(data.data.data) {
              this.organizationData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.loadOrganization();
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
